import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { secureStorage } from "@/infrastructure/storage";
import { STORAGE_KEYS } from "@/domain/constants/storage";
import { LOCALES } from "@/domain/constants/locales";
import { resources } from "./locales";

// 從安全儲存中獲取語言偏好，如果沒有則使用預設值
const savedLanguage =
  secureStorage.getItem(STORAGE_KEYS.LANGUAGE) || LOCALES.DEFAULT;

// 使用明確的類型註解來避免警告
i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage as string,
  fallbackLng: LOCALES.DEFAULT,
  interpolation: { escapeValue: false },
  returnNull: false,
});

// 監聽語言變更事件，保存到安全儲存
i18n.on("languageChanged", (lng) => {
  secureStorage.setItem(STORAGE_KEYS.LANGUAGE, lng);
});

/**
 * 切換語言函數
 * @param language 語言代碼 (LOCALES.EN 或 LOCALES.ZH_TW)
 */
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
};

export default i18n;
